module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "余剰ライセンス割当依頼一覧"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n        件数\n      ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "border-color": "#7D2A2B",
      "background": "rgb(185 87 77)"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runSurplusLicenseDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dde6737","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0020_surplus_license_request.vue
// module id = 1041
// module chunks = 0